import { render, staticRenderFns } from "./BadgeOrderStatistics.vue?vue&type=template&id=1a77421e&scoped=true"
import script from "./BadgeOrderStatistics.vue?vue&type=script&lang=js"
export * from "./BadgeOrderStatistics.vue?vue&type=script&lang=js"
import style0 from "./BadgeOrderStatistics.vue?vue&type=style&index=0&id=1a77421e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a77421e",
  null
  
)

export default component.exports